import api from './client.js'

export const testEnvAPI = {
  status:       ()             => api.get('/test/status'),
  seedUsers:    ()             => api.post('/test/users/seed'),
  wisUsers:     ()             => api.delete('/test/users'),
  maakGhost:    (userId, min)  => api.post('/test/ghost/create', { userId, minuten: min }),
  gebruikGhost: (token)        => api.post(`/test/ghost/redeem/${token}`),

  // Test-flow runs
  listFlows:    ()                       => api.get('/test/flows'),
  startRun:     (flowId)                 => api.post(`/test/flows/${flowId}/runs`),
  getRun:       (runId)                  => api.get(`/test/flows/runs/${runId}`),
  setStep:      (runId, stepId, body)    => api.patch(`/test/flows/runs/${runId}/steps/${stepId}`, body),
  resetRun:     (runId)                  => api.post(`/test/flows/runs/${runId}/reset`),
  completeRun:  (runId)                  => api.post(`/test/flows/runs/${runId}/complete`),
}
